// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"switch-group_wrapper__29TWR","item":"switch-group_item__4d0-9"};